import React from "react";
import Hero from "../components/sections/Hero";
import NoAppSection from "../components/sections/NoAppSection";
import EventCategories from "../components/sections/EventCategories";
import PricingTeaser from "../components/sections/PricingTeaser";
import Stats from "../components/sections/Stats";
import Testimonials from "../components/sections/Testimonials";
import WhatsNew from "../components/sections/WhatsNew";
import CtaBand from "../components/sections/CtaBand";
import AboutLong from "../components/sections/AboutLong";

const HomePage = () => (
  <>
    <Hero />
    <NoAppSection />
    <EventCategories />
    <PricingTeaser />
    <Stats />
    <Testimonials />
    <WhatsNew />
    <CtaBand />
    <AboutLong />
    <EventCategories title="What Event Will You Collect Photos From?" subtitle="" />
  </>
);

export default HomePage;
